module.exports = __webpack_public_path__ + "static/media/ic_invest_gold.a6104011.svg";